import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { ElementService } from '../../../resources/element/element.service';
import { ProjectElement } from '../../../resources/element/project-element.interface';
import { FormControl } from '@angular/forms';
import { UserService } from '../../../resources/user/user.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { User } from '../../../resources/user/user.interface';
import { ModalService } from '../../../services/modal/modal.service';

/**
 * Dropdown with users to assign to element.
 */
@Component({
  selector: 'sg2-element-assign-to',
  templateUrl: './element-assign-to.component.html',
  styleUrls: ['./element-assign-to.component.less']
})
export class ElementAssignToComponent implements OnDestroy, OnInit {

  /** Current element. */
  @Input() element: ProjectElement;

  /** Whether to show form label. */
  @Input() label: boolean;

  /** Users form. */
  public assign: FormControl;

  /** Unsubscribe hook. */
  private _destroy$ = new Subject<any>();

  constructor(
    public elementService: ElementService,
    private modalService: ModalService,
    public userService: UserService
  ) {}

  ngOnInit() {
    this.assign = new FormControl(this.element.assignedToUserId || -1);
    this.elementService.element$.pipe(
      takeUntil(this._destroy$)
    ).subscribe(elements => {
      this.element = elements.find(e => e.identifier === this.element.identifier);
    });
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }

  /**
   * has the element an assigned user.
   *
   * @returns boolean.
   */
  public hasUser(): boolean {
    return this.element.assignedToUserId && this.element.assignedToUserId !== -1;
  }

  /**
   * Get user object for current assigned user.
   *
   * @returns User object.
   */
  public getUser(): User {
    return this.userService.getUser(this.element.assignedToUserId);
  }

  /**
   * Assign user to element.
   *
   * @param userId The id of the user to assign to the element.
   */
  public setUser(userId: User['_id']): void {
    this.modalService.openAssignTo(this.element, { user: userId }).afterClosed().subscribe(settings => {
      if (settings) {
        this.elementService.assignToWithOptions(this.element, settings);
      }
    });
  }
}
